import { render, staticRenderFns } from "./SvgRenderer.vue?vue&type=template&id=16d2a6b2"
import script from "./SvgRenderer.vue?vue&type=script&lang=js"
export * from "./SvgRenderer.vue?vue&type=script&lang=js"
import style0 from "./SvgRenderer.vue?vue&type=style&index=0&id=16d2a6b2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports